import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import { useToasts } from "react-toast-notifications";
import AdminAjoutMarque from "./AdminAjoutMarque";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";

const API_URL = process.env.REACT_APP_API_URL;

function Marques() {
  const [show, setShow] = useState(false);
  const [marques, setMarques] = useState([]);
  const { addToast } = useToasts();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    function getMarque() {
      axios
        .get(`${API_URL}/api/marques`)
        .then((res) => {
          setMarques(res.data);
        })
        .catch((e) => {
          if (e.response.status === 401) {
            addToast("Votre session est expirée. Merci de vous reconnecter.", {
              appearance: "warning",
              autoDismiss: true,
            });
          } else {
            addToast(`Erreur : ${e.message}`, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    }

    getMarque();
  }, []);

  let lettrePrecedente = "";

  return (
    <div>
      <h1>Gestion des marques</h1>
      <MDBBtn type="button" outline color="primary" onClick={handleShow}>
        Ajouter une marque
      </MDBBtn>
      <ul>
        {marques ? (
          marques.map((marque) => {
            if (marque.nom.charAt(0).toUpperCase() !== lettrePrecedente) {
              lettrePrecedente = marque.nom.charAt(0).toUpperCase();
              return (
                <div>
                  <div className="initial">{lettrePrecedente}</div>
                  <ul className="firstAfterInitial">
                    <li key={marque.id}>
                      <Link to={`/marque-admin/${marque.id}`}>
                        {marque.nom}
                      </Link>
                    </li>
                  </ul>
                </div>
              );
            } else {
              return (
                <div>
                  <ul>
                    <li key={marque.id}>
                      <Link to={`/marque-admin/${marque.id}`}>
                        {marque.nom}
                      </Link>
                    </li>
                  </ul>
                </div>
              );
            }
          })
        ) : (
          <li>Loading</li>
        )}
      </ul>
      <MDBContainer>
        <MDBModal isOpen={show} toggle={handleClose}>
          <MDBModalHeader>Créer une marque</MDBModalHeader>
          <MDBModalBody>
            <AdminAjoutMarque />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type="button" outline color="primary" onClick={handleClose}>
              Fermer
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default Marques;
